import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ItemGeneralListado } from '../../../helpers/components/itemClasses/itemListadoGeneral.class';
import { ProductsService } from '../../../infrastructure/services/products.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'configurar-product',
  templateUrl: './configurar.component.html',
  providers: [ProductsService]
})
export class ConfigurarNuevoProductComponent implements OnInit {
  codSubscription: string;
  codChannel: string;
  buscarChannel: String;
  availablesProducts: Observable<ItemGeneralListado[]>;
  tituloListado: String = 'Nuevo producto';
  cargandoProductos: Boolean = true;
  constructor(private aRoute: ActivatedRoute, private productsService: ProductsService ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
        // Parametros URL
        this.codSubscription = params['codsistema'];
        this.codChannel = params['codsistema'];

        // Obtenemos la configuracion para el nivel
        this.availablesProducts = this.productsService.getNewAvailablesProducts(this.codSubscription, this.codChannel);
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/product/configurar.component.ts